import {ShieldX} from "lucide-react";
import {Link, Outlet} from "react-router-dom";
import {
    canAccessAdminSection,
    getDefaultPathForCapabilities,
} from "./navigation";

export const AdminRouteGuard = ({role, modules, actions, sectionKey, allowedRoles}) => {
    const capabilities = {role, modules, actions};
    const sectionAllowed = canAccessAdminSection({...capabilities, sectionKey});
    if (sectionAllowed && (!allowedRoles || allowedRoles.includes(role))) return <Outlet />;

    return (
        <section className="admin-page" aria-labelledby="admin-access-title">
            <div className="admin-card admin-empty-state">
                <ShieldX aria-hidden="true" size={28} />
                <div>
                    <h1 id="admin-access-title">Доступ запрещен</h1>
                    <p>Эта секция недоступна для текущей роли.</p>
                </div>
                <Link
                    className="admin-button admin-button-secondary"
                    to={getDefaultPathForCapabilities(capabilities)}
                >
                    Вернуться
                </Link>
            </div>
        </section>
    );
};
